export default {
  // Default light variant
  light: {
    tooltip: "max-w-[calc(100vw-2rem)] md:max-w-[500px] bg-admin_canvas text-admin_text text-sm px-2 py-1 rounded shadow-lg border border-admin_bordered",
  },

  // Dark variant for button menus and similar
  dark: {
    tooltip: "max-w-[calc(100vw-2rem)] md:max-w-[500px] bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg",
  },

  // Admin variant
  admin: {
    tooltip: "max-w-[calc(100vw-2rem)] md:max-w-[500px] bg-admin_paper text-admin_text text-sm px-3 py-2 rounded-lg shadow-xl border border-admin_bordered",
  }
}